import { actionPermissionGQLFields, } from './actionPermissions.fields.js';
const BASIC_MEMBER_AUTH_MEMBER_PROPS_FIELDS = {};
const ALL_MEMBER_AUTH_MEMBER_PROPS_FIELDS = {
    permissions: 'basic',
};
export function memberAuthMemberPropsGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_MEMBER_AUTH_MEMBER_PROPS_FIELDS;
    if (fields === 'all')
        fields = ALL_MEMBER_AUTH_MEMBER_PROPS_FIELDS;
    return `
    context
    scopes
    canSendPrivateMessages
    ${fields.permissions
        ? `
      permissions {
        ${actionPermissionGQLFields(fields.permissions)}
      }
    `
        : ``}
  `;
}
//# sourceMappingURL=memberAuthMemberProps.fields.js.map